export default __webpack_public_path__ + "1b70fdd519ba0b6f2fa3a147a22a5a27.svg";